import { action } from 'satcheljs';

export interface FlexPaneOpenedActionMessage {
    flexPaneId: string;
}
const flexPaneOpened: (flexPaneId: string) => FlexPaneOpenedActionMessage = action(
    'flexPaneOpened',
    (flexPaneId: string): FlexPaneOpenedActionMessage => ({
        flexPaneId,
    })
);

export default flexPaneOpened;
